import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { routeConfigs } from '../../common/constants/route.config';
import { UnsavedChangesGuard } from '../../common/guards';
import { AuthGuard } from '../../guards/auth.guard';
import { PlaceGuard } from '../../guards/place.guard';
import { TripPlannerGuard } from '../../guards/trip.planner';
import { AccountsComponent } from '../admin/accounts/accounts.component';
import { SetApprovedComponent } from '../admin/accounts/set.approved/set.approved.component';
import { AdminComponent } from '../admin/admin.component';
import { AuthComponent } from '../auth/auth.component';
import { LoginComponent } from '../auth/login/login.component';
import { FallComponent } from '../fall.component';
import { GpsRedirectComponent } from '../gps.redirect.component';
import { HubCalendarComponent } from '../hub/calendar/hub.calendar.component';
import { MarketingComponent } from '../hub/customization/marketing/marketing.component';
import { StyleComponent } from '../hub/customization/style/style.component';
import { EventBriteAddComponent } from '../hub/edit.eventbrite/event.brite.add.component';
import { UploadEventsComponent } from '../hub/upload.events/upload.events.component';
import { TourComponent } from '../hub/tours/tours/tour.component';
import { CreateEventComponent } from '../hub/manually.add/create.event/create.event.component';
// import {EventAddFormComponent} from '../hub/edit.account/event.add.form.component';
import { BlockKeywordsComponent } from '../hub/block.keywords/block.keywords.component';
import { HubComponent } from '../hub/hub.component';
import { ManuallyAddComponent } from '../hub/manually.add/manually.add.component';
import { VisitorCalendarComponent } from '../visitor/calendar/visitor.calendar.component';
import { VisitorCreateEventComponent } from '../visitor/create.event/create.event.component';
import { VisitorCreatePlaceComponent } from '../visitor/create.place/create.place.component';
import { VisitorEventDetailsComponent } from '../visitor/event.details/visitor.event.details.component';
import { VisitorEventMapComponent } from '../visitor/event.map/visitor.event.map.component';
import { VisitorPlaceDetailsComponent } from '../visitor/place.details/visitor.place.details.component';
import { VisitorPlaceMapComponent } from '../visitor/place.map/visitor.place.map.component';
import { VisitorTripComponent } from '../visitor/trip/visitor.trip.component';
import { VisitorComponent } from '../visitor/visitor.component';
import { EventGuard } from 'guards/event.guard';
import {
  ContentManagementComponent
} from 'components/hub/edit.account/content.management/content.management.component';
import { NotFoundGuard } from '../../guards/not.found.guard';
import { HubSimilarCalendarComponent } from '../hub/similar.calendar/hub.similar.calendar.component';
import { AISettingsComponent } from '../hub/ai.settings/ai.settings.component';
import { HubSimilarPlaceCalendarComponent } from '../hub/similar.place.calendar/hub.similar.place.calendar.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: routeConfigs.auth.path,
    pathMatch: 'full',
  },
  {
    path: routeConfigs.auth.path,
    component: AuthComponent,
    children: [
      {
        path: routeConfigs.auth.login.path,
        component: LoginComponent,
      },
    ],
  },
  {
    path: routeConfigs.admin.path,
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: routeConfigs.admin.accounts.path,
        component: AccountsComponent,
      },
    ],
  },
  {
    path: routeConfigs.hub.path,
    component: HubComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: routeConfigs.hub.eventCalendar.path,
        component: HubCalendarComponent,
      },
      {
        path: routeConfigs.hub.similarEventCalendar.path,
        component: HubSimilarCalendarComponent,
      },
      {
        path: routeConfigs.hub.placeCalendar.path,
        component: HubCalendarComponent,
      },
      {
        path: routeConfigs.hub.similarPlaceCalendar.path,
        component: HubSimilarPlaceCalendarComponent,
      },
      // {
      //     path: routeConfigs.hub.editAccount.path,
      //     component: EventAddFormComponent
      // },
      {
        path: routeConfigs.hub.contentManagement.path,
        component: ContentManagementComponent,
      },
      {
        path: routeConfigs.hub.blockKeywords.path,
        component: BlockKeywordsComponent,
      },
      {
        path: routeConfigs.hub.aiSettings.path,
        component: AISettingsComponent,
      },
      {
        path: routeConfigs.hub.editEventBriteAccount.path,
        component: EventBriteAddComponent,
      },
      {
        path: routeConfigs.hub.customization.path,
        component: StyleComponent,
      },
      {
        path: routeConfigs.hub.marketing.path,
        component: MarketingComponent,
      },
      {
        path: routeConfigs.hub.uploadEvents.path,
        component: UploadEventsComponent,
      },
      {
        path: routeConfigs.hub.manuallyAdd.path,
        component: ManuallyAddComponent,
      },
      {
        path: routeConfigs.hub.tours.path,
        component: TourComponent,
      },
      {
        canDeactivate: [UnsavedChangesGuard],
        path: routeConfigs.hub.createEvent.path,
        component: CreateEventComponent,
      },
    ],
  },
  {
    path: routeConfigs.waterFall.path,
    component: FallComponent,
  },
  {
    path: routeConfigs.gps.path,
    component: GpsRedirectComponent,
  },
  {
    path: routeConfigs.submit.event.path,
    component: VisitorCreateEventComponent,
  },
  {
    path: routeConfigs.submit.place.path,
    component: VisitorCreatePlaceComponent,
  },
  {
    path: routeConfigs.visitor.path,
    component: VisitorComponent,
    children: [
      {
        path: routeConfigs.visitor.eventCalendar.path,
        component: VisitorCalendarComponent,
      },
      {
        path: routeConfigs.visitor.eventMap.path,
        component: VisitorEventMapComponent,
        canActivate: [EventGuard],
      },
      {
        path: routeConfigs.visitor.editorChoice.path,
        component: VisitorCalendarComponent,
      },
      {
        path: routeConfigs.visitor.eventDetails.path,
        component: VisitorEventDetailsComponent,
        canActivate: [EventGuard],
      },
      {
        path: routeConfigs.visitor.eventDetailsModal.path,
        component: VisitorCalendarComponent,
        canActivate: [EventGuard],
      },
      {
        path: routeConfigs.visitor.customEvent.path,
        component: VisitorCalendarComponent,
        canActivate: [EventGuard],
      },
      {
        path: routeConfigs.visitor.customPlace.path,
        component: VisitorCalendarComponent,
        canActivate: [PlaceGuard],
      },
      {
        path: routeConfigs.visitor.placeDetails.path,
        component: VisitorPlaceDetailsComponent,
        canActivate: [PlaceGuard],
      },
      {
        path: routeConfigs.visitor.placeDetailsWithCategory.path,
        canActivate: [PlaceGuard],
        component: VisitorPlaceDetailsComponent,
      },
      {
        path: routeConfigs.visitor.placeCalendar.path,
        component: VisitorCalendarComponent,
      },
      {
        path: routeConfigs.visitor.placeMap.path,
        canActivate: [PlaceGuard],
        component: VisitorPlaceMapComponent,
      },
      {
        path: routeConfigs.visitor.placeEditorChoice.path,
        component: VisitorCalendarComponent,
      },
      {
        path: routeConfigs.visitor.placeDetailsNotSimple.path,
        canActivate: [PlaceGuard],
        component: VisitorPlaceDetailsComponent,
      },
      {
        path: routeConfigs.visitor.placeDetailsModal.path,
        canActivate: [PlaceGuard],
        component: VisitorCalendarComponent,
      },
      {
        path: routeConfigs.visitor.placeCalendarNotSimple.path,
        component: VisitorCalendarComponent,
      },
      {
        path: routeConfigs.visitor.placeMapNotSimple.path,
        canActivate: [PlaceGuard],
        component: VisitorPlaceMapComponent,
      },
      {
        path: routeConfigs.visitor.createEvent.path,
        component: VisitorCreateEventComponent,
      },
      {
        path: routeConfigs.visitor.createPlace.path,
        //canActivate: [PlaceGuard],
        component: VisitorCreatePlaceComponent,
      },
    ],
  },
  {
    path: routeConfigs.tripPlanner.path,
    component: VisitorTripComponent,
    children: [
      {
        path: routeConfigs.tripPlanner.trip.path,
        component: VisitorTripComponent,
        canActivate: [TripPlannerGuard],
      },
      {
        path: routeConfigs.tripPlanner.region.path,
        component: VisitorTripComponent,
        canActivate: [TripPlannerGuard],
      },
      {
        path: routeConfigs.tripPlanner.tripShare.path,
        component: VisitorTripComponent,
        canActivate: [TripPlannerGuard],
      },
      {
        path: routeConfigs.tripPlanner.singleTripShare.path,
        component: VisitorTripComponent,
        canActivate: [TripPlannerGuard],
      },
      {
        path: routeConfigs.tripPlanner.tourShare.path,
        component: VisitorTripComponent,
        canActivate: [TripPlannerGuard],
      },
      {
        path: routeConfigs.tripPlanner.tourList.path,
        component: VisitorTripComponent,
        canActivate: [TripPlannerGuard],
      },
      {
        path: routeConfigs.tripPlanner.tourPDF.path,
        component: VisitorTripComponent,
        canActivate: [TripPlannerGuard],
      },
    ],
  },
  // {
  //     path: '**', pathMatch: 'full',
  //     // redirectTo: 'https://imgoingcalendar.com/assets/pages/404.html',
  //     canActivate: [NotFoundGuard],
  //     component: NotFoundGuard,
  //     data: {
  //         externalUrl: 'https://imgoingcalendar.com/assets/pages/404.html'
  //     }
  // }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  entryComponents: [SetApprovedComponent],
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/app/app.routing.module.ts